module.exports = __webpack_public_path__ + "img/homepage-theme-background-pink.5e71b810.svg";